'use client'

type Props = {
    desktopSrc: string
    mobileSrc: string
    alt: string
    cssClass?: string
    onLoad?: () => void;
    isBackground?: boolean
}

export default function ResponsiveImage({desktopSrc, mobileSrc, alt, cssClass, onLoad, isBackground}:Props){
    return (
        <>
            {
                isBackground ?
                <>
                    <div
                        className={`${cssClass} responsive-bg w-full h-full bg-cover bg-center bg-no-repeat`}
                        style={{
                        '--desktop-bg': `url(${desktopSrc})`,
                        '--mobile-bg': `url(${mobileSrc || desktopSrc})`,
                        } as React.CSSProperties}
                    />
                    <style jsx>{`
                        .responsive-bg {
                            background-image: var(--mobile-bg);
                        }

                        @media (min-width: 600px) {
                            .responsive-bg {
                            background-image: var(--desktop-bg);
                            }
                        }
                    `}</style>
                </>
                :<picture>
                    {mobileSrc && (
                        <source
                            media="(max-width: 600px)"
                            srcSet={mobileSrc}
                        />
                    )}

                    <img
                        src={desktopSrc}
                        alt={alt}
                        className={cssClass}
                        onLoad={onLoad}
                    />
                </picture>
            }
        </>
    )
}